/**
 * <s-slider> — horizontal scroll-snap slider.
 * Prev/next buttons target this element with commandfor and the custom
 * commands `--prev` / `--next`. The track is the element's [data-slider-track] child.
 */
class SSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.onCommand = (event) => {
      if (!this.track) return;
      const direction = event.command === '--next' ? 1 : event.command === '--prev' ? -1 : 0;
      if (!direction) return;
      const item = this.track.firstElementChild;
      const step = item ? item.getBoundingClientRect().width + 8 : this.track.clientWidth * 0.8;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: step * direction * (document.dir === 'rtl' ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
    };
    this.addEventListener('command', this.onCommand);
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.onCommand);
  }
}

if (!customElements.get('s-slider')) customElements.define('s-slider', SSlider);
